<ng-select
  [items]="options"
  bindLabel="description"
  [multiple]="allowMultiselect"
  [(ngModel)]="selectedOptions"
  (change)="onChange($event)"
  class="custom-multiselect auto-width"
  [searchable]="false"
  [libAutoWidth]="options"
  [bindLabel]="'description'"
  [translatedLabel]="'translatedDescription'"
  [hasIcon]="hasAtLeastOneOptionIcon()"
  [clearable]="true"
  [closeOnSelect]="!allowMultiselect"
  [placeholder]="getPlaceholder()"
>
  <ng-template ng-label-tmp let-item="item" let-clear="clear">
    <span class="d-flex align-items-center me-1">
      <lib-svg *ngIf="item.icon?.svg" [svg]="item.icon.svg" size="20px"></lib-svg>
      <span style="font-size: 1rem;">
        <lib-translated-string [translation]="item.translatedDescription"></lib-translated-string>
      </span>
    </span>
  </ng-template>
  <ng-template ng-option-tmp let-item="item">
    <span class="d-flex align-items-center gap-1">
      <lib-svg *ngIf="item.icon?.svg" [svg]="item.icon.svg" size="20px"></lib-svg>
      <span style="font-size: 1rem;"><lib-translated-string [translation]="item.translatedDescription"></lib-translated-string></span>
    </span>
  </ng-template>
</ng-select>
